/* Copyright (c) 2021 Paul Nebel */

import React from 'react';
import { connect } from 'react-redux';
import { flatten } from 'lodash';
import { CarouselProvider } from 'pure-react-carousel';

import MetronomeContainer from '../containers/metronome-container';
import ViewerCarousel from '../containers/viewer-carousel';
import ThumbnailCollection from '../components/thumbnail-collection';
import PlayHead from '../components/play-head';
import NumberSlider from '../components/number-slider';
import EventIconToggleButton from '../components/event-icon-toggle-button';
import { component as EventButton } from '../components/event-button';
import withSplashPage from '../components/splash-page';
import ChordSounds from '../components/chord-sounds';

import * as styles from '../styles/components.module.css';

const chords = [
    [
        'C',
        'F',
        'Bb',
        'Eb',
    ],
    [
        'Ab',
        'Db',
        'Gb',
        'B',
    ],
    [
        'E',
        'A',
        'D',
        'G',
    ],
    // [
    //     'C#',
    //     'D#',
    //     'F#',
    //     'G#',
    // ],
];

class GameContainer extends React.Component {
    render() {
        return (
            <div className='container is-max-desktop'>
                <div className='columns is-vcentred  is-flex-direction-column'>
                    <div id='metronome-container' className='column has-text-centered'>
                        <MetronomeContainer 
                            volume={ -18 }
                            bpm={ 60 }
                        />
                    </div>
                    <div id={`${ styles.tempoSlider }`} className='column has-text-centered'>
                        <NumberSlider
                            name='bpm'
                            label='BPM'
                            value={ 60 }
                            min={ 40 }
                            max={ 140 }
                            step={ 1 }
                            minIcon='fa-tachometer-slow'
                            maxIcon='fa-tachometer-fast'
                        />
                    </div>
                    <div className={ `${ styles.volumeSlider } column has-text-centered` }>
                        <NumberSlider
                            name='metroVolume'
                            label='dB'
                            value={ -24 }
                            min={ -36 }
                            max={ 0 }
                            step={ 1 }
                            minIcon='fa-volume-down'
                            maxIcon='fa-volume-up'
                        />
                    </div>
                    <div className={ `${ styles.volumeSlider } column has-text-centered` }>
                        <NumberSlider
                            name='chordVolume'
                            label='dB'
                            value={ -6 }
                            min={ -36 }
                            max={ 0 }
                            step={ 1 }
                            minIcon='fa-music-alt'
                            maxIcon='fa-music'
                        />
                    </div>
                </div>
                <ChordSounds />
                <div id='thumbnails' className='columns is-vcentred'>
                    <div className='column has-text-centered'>
                        <ThumbnailCollection chords={ chords } />
                    </div>
                </div>
                <div id={`${ styles.playerButtons }`} className='columns is-vcentred is-mobile is-gapless'>
                    <div className='column has-text-centered is-2'>
                        <EventIconToggleButton
                            event='shuffle'
                            trueIcon='random'
                            falseIcon='random'
                            toggleState={ false }
                        />
                    </div>
                    <div className='column has-text-centered is-2'>
                        <EventIconToggleButton
                            event='repeat'
                            trueIcon='repeat'
                            falseIcon='repeat'
                            toggleState={ true }
                        />
                    </div>
                    <div className='column has-text-centered is-4'>
                        <PlayHead
                            length={ flatten(chords).length }
                            loopDuration={ '1:0:0' }
                        />
                    </div>
                    <div className='column has-text-centered is-2'>
                        <EventButton
                            event='1inv'
                            text='Ib'
                            disabled={ true }
                        />
                    </div>
                    <div className='column has-text-centered is-2'>
                        <EventButton
                            event='2inv'
                            text='Ic'
                            disabled={ true }
                        />
                    </div>
                </div>
                <div id='carousel' className='columns is-vcentred is-mobile'>
                    <div className='column has-text-centered'>
                        <CarouselProvider
                            naturalSlideWidth={ 100 }
                            naturalSlideHeight={ 50 }
                            totalSlides={ 3 }
                            infinite={ true }
                        >
                            <ViewerCarousel />
                        </CarouselProvider>
                    </div>
                </div>
            </div>
        );
    }
}

export default withSplashPage(connect(
    null,
    null,
)(GameContainer));